"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var api_1 = require("../../utils/api");
var toolkit_1 = require("@reduxjs/toolkit");
var graph_ql_1 = require("../../types/graph-ql");
var getCollection_1 = require("./queries/getCollection");
var getBrowseCategories_1 = __importDefault(require("./queries/getBrowseCategories"));
var constants_1 = require("./constants");
var selectors_1 = require("./selectors");
var selectors_2 = require("../auth/selectors");
var config_1 = __importStar(require("../../config"));
exports.getInitialFiltersVal = function (isLoggedIn) {
    var _a;
    return (_a = {},
        _a[constants_1.COLLECTION_FILTER_GENRE] = constants_1.COLLECTION_FILTER_VALUE_ALL,
        _a[constants_1.COLLECTION_FILTER_SUBSCRIPTION] = isLoggedIn
            ? constants_1.COLLECTION_FILTER_VALUE_MYSUBSCRIPTION
            : constants_1.COLLECTION_FILTER_VALUE_ALL,
        _a);
};
exports.browseMoreFiltersValues = (_a = {},
    _a[constants_1.COLLECTION_FILTER_GENRE] = constants_1.COLLECTION_FILTER_VALUE_ALL,
    _a[constants_1.COLLECTION_FILTER_SUBSCRIPTION] = constants_1.COLLECTION_FILTER_VALUE_ALL,
    _a[constants_1.COLLECTION_FILTER_VIEWINGCONTEXT] = constants_1.COLLECTION_FILTER_VALUE_ALL,
    _a[constants_1.COLLECTION_FILTER_SORT] = graph_ql_1.CollectionOrder.Newest,
    _a);
var viewingContextValueMap = (_b = {},
    _b[graph_ql_1.ViewingContext.Vod] = constants_1.COLLECTION_FILTER_VALUE_ONDEMAND,
    _b[graph_ql_1.ViewingContext.Catchup] = constants_1.COLLECTION_FILTER_VALUE_ONDEMAND,
    _b[graph_ql_1.ViewingContext.Linear] = constants_1.COLLECTION_FILTER_VALUE_UPCOMING_ON_TV,
    _b[graph_ql_1.ViewingContext.Download] = constants_1.COLLECTION_FILTER_VALUE_DOWNLOADABLE,
    _b);
var onDemandViewingContexts = new Set([graph_ql_1.ViewingContext.Vod, graph_ql_1.ViewingContext.Catchup]);
var getDefaultFilters = function (categoryOrCollection) {
    var _a;
    var _b, _c;
    var viewingContext = (_c = (_b = categoryOrCollection === null || categoryOrCollection === void 0 ? void 0 : categoryOrCollection.defaultContentFilter) === null || _b === void 0 ? void 0 : _b.viewingContextsByContentType) === null || _c === void 0 ? void 0 : _c.viewingContexts;
    var vcFilter;
    if ((viewingContext === null || viewingContext === void 0 ? void 0 : viewingContext.length) > 0) {
        if ((viewingContext === null || viewingContext === void 0 ? void 0 : viewingContext.length) > 1) {
            if (viewingContext.length === onDemandViewingContexts.size &&
                __spreadArrays(viewingContext).every(function (vc) { return onDemandViewingContexts.has(vc); })) {
                vcFilter = constants_1.COLLECTION_FILTER_VALUE_ONDEMAND;
            }
            else {
                // error state, since it's just a filter we can go with 'all' to fail gracefully.
                vcFilter = constants_1.COLLECTION_FILTER_VALUE_ALL;
            }
        }
        else {
            var filter = viewingContext === null || viewingContext === void 0 ? void 0 : viewingContext[0];
            vcFilter = viewingContextValueMap === null || viewingContextValueMap === void 0 ? void 0 : viewingContextValueMap[filter];
        }
    }
    return _a = {},
        _a[constants_1.COLLECTION_FILTER_VIEWINGCONTEXT] = vcFilter,
        _a[constants_1.COLLECTION_FILTER_SORT] = categoryOrCollection === null || categoryOrCollection === void 0 ? void 0 : categoryOrCollection.defaultContentSort,
        _a;
};
exports.setCollectionFilters = function (collectionId, filters) {
    return toolkit_1.createAction(constants_1.SET_COLLECTION_FILTERS)({
        collectionId: collectionId,
        filters: filters,
    });
};
exports.fetchCollection = function (collectionId, size, isLoadMore, enabledFilters, reload) {
    if (isLoadMore === void 0) { isLoadMore = false; }
    if (enabledFilters === void 0) { enabledFilters = [
        constants_1.COLLECTION_FILTER_GENRE,
        constants_1.COLLECTION_FILTER_SUBSCRIPTION,
        constants_1.COLLECTION_FILTER_VIEWINGCONTEXT,
        constants_1.COLLECTION_FILTER_SORT,
    ]; }
    return function (dispatch, getState) {
        var _a, _b, _c, _d;
        var pageInfo = { size: size };
        var collection = selectors_1.getCollection(getState())(collectionId);
        if (isLoadMore) {
            pageInfo.after = (_a = collection === null || collection === void 0 ? void 0 : collection.contentPage) === null || _a === void 0 ? void 0 : _a.pageInfo.endCursor;
        }
        else if (reload) {
            pageInfo = {
                size: Array.isArray((_b = collection === null || collection === void 0 ? void 0 : collection.contentPage) === null || _b === void 0 ? void 0 : _b.content)
                    ? (_d = (_c = collection === null || collection === void 0 ? void 0 : collection.contentPage) === null || _c === void 0 ? void 0 : _c.content) === null || _d === void 0 ? void 0 : _d.length : size,
            };
        }
        var selectedFilters = selectors_1.getCollectionSelectedFilters(getState())(collectionId);
        var loggedInUser = selectors_2.user(getState());
        selectedFilters = __assign(__assign({}, exports.getInitialFiltersVal(!ramda_1.isNil(loggedInUser))), selectedFilters);
        // for anonymous users, they should always see all the contents.
        if (ramda_1.isNil(loggedInUser)) {
            selectedFilters[constants_1.COLLECTION_FILTER_SUBSCRIPTION] = constants_1.COLLECTION_FILTER_VALUE_ALL;
        }
        var queryfilters = enabledFilters
            .filter(function (filter) { return !ramda_1.isNil(selectedFilters[filter]); })
            .reduce(function (acc, key) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[key] = selectedFilters[key], _a)));
        }, {});
        return dispatch(api_1.createApiAction(constants_1.FETCH_COLLECTION, {
            baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
            params: {
                query: getCollection_1.GET_COLLECTION(queryfilters, pageInfo),
                variables: { collectionId: collectionId },
            },
            meta: { collectionId: collectionId, selectedFilters: queryfilters, isLoadMore: isLoadMore },
            authenticated: true,
            graphQL: true,
            onlyLatest: true,
            onSuccess: function (dispatch1, _a) {
                var payload = _a.payload;
                var _b;
                dispatch1(exports.setCollectionFilters((_b = payload.collection) === null || _b === void 0 ? void 0 : _b.id, __assign(__assign({}, getDefaultFilters(payload.collection)), selectedFilters)));
            },
        }));
    };
};
exports.fetchHomeCollection = function (collectionId) {
    return api_1.createApiAction(constants_1.FETCH_HOME_COLLECTION, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: getCollection_1.GET_COLLECTION(),
            variables: { collectionId: collectionId },
        },
        meta: { collectionId: collectionId },
        authenticated: true,
        graphQL: true,
    });
};
exports.setCollectionFilter = function (collectionId, name, value) {
    return toolkit_1.createAction(constants_1.SET_COLLECTION_FILTER)({
        collectionId: collectionId,
        name: name,
        value: value,
    });
};
exports.clearCollectionFilters = function (collectionId) {
    return toolkit_1.createAction(constants_1.CLEAR_COLLECTION_FILTERS)({
        collectionId: collectionId,
    });
};
exports.setBrowseMoreFilters = function (collectionId) {
    return exports.setCollectionFilters(collectionId, exports.browseMoreFiltersValues);
};
var setDefaultFilterAction = function (category, dispatch, getState) {
    if (category) {
        var loggedInUser = selectors_2.user(getState());
        dispatch(exports.setCollectionFilters(category.id, __assign(__assign({}, getDefaultFilters(category)), exports.getInitialFiltersVal(!ramda_1.isNil(loggedInUser)))));
    }
};
exports.fetchBrowseCategories = function (excludeDownloads) {
    if (excludeDownloads === void 0) { excludeDownloads = false; }
    return function (dispatch, getState) {
        return dispatch(api_1.createApiAction(constants_1.FETCH_BROWSE_CATEGORIES, {
            baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
            params: {
                query: getBrowseCategories_1.default,
                variables: { excludeViewingContexts: excludeDownloads ? [graph_ql_1.ViewingContext.Download] : [] },
            },
            authenticated: true,
            graphQL: true,
            onSuccess: function (_, _a) {
                var payload = _a.payload;
                var _b, _c;
                (_c = (_b = payload.section) === null || _b === void 0 ? void 0 : _b.home) === null || _c === void 0 ? void 0 : _c.categories.forEach(function (category) {
                    return setDefaultFilterAction(category, dispatch, getState);
                });
            },
        }));
    };
};
exports.setDefaultFilter = function (collectionId) { return function (dispatch, getState) {
    var _a;
    var category = (_a = selectors_1.getBrowseCategories(getState())) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.id === collectionId; });
    setDefaultFilterAction(category, dispatch, getState);
}; };
//# sourceMappingURL=actions.js.map